import { documentBundleActions } from 'src/redux/actions/constant';

const {
  SUCCESS_GET_PATIENT_INTERVALS,
  FAILURE_GET_PATIENT_INTERVALS,
  LOADING_GET_PATIENT_INTERVALS,
  RESET_GET_PATIENT_INTERVALS,
} = documentBundleActions;

const initialState = {
  response: null as any,
  loading: false,
};

export const getPatientIntervalsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOADING_GET_PATIENT_INTERVALS:
      return { ...state, loading: true };
    case SUCCESS_GET_PATIENT_INTERVALS:
      return { ...state, loading: false, response: action.payload };
    case FAILURE_GET_PATIENT_INTERVALS:
      return { ...state, loading: false, response: null };
    case RESET_GET_PATIENT_INTERVALS:
      return initialState;
    default:
      return state;
  }
};
